import { InteractiveSubItemComponent, interactiveSubItemTemplate } from './InteractiveSubItem';
import styles from './InteractiveSubItem.styles.scss';
export const interactiveSubItemDefinition = {
    baseName: 'interactive-sub-item',
    template: interactiveSubItemTemplate,
    styles,
};
export const chameleonInteractiveSubItem = InteractiveSubItemComponent.compose(interactiveSubItemDefinition);
